export const grid = { startx: 21, dx: 49, starty: 5, dy: 81 }

export const minProjectileLen = 50
export const maxProjectileLen = 700

export const minDurationMs = 5000
export const maxDurationMs = 15000

export const minSteps = 8000
export const maxSteps = 12000

export const projectileCount = 10

export const lineColor = 'hsla(0, 0%, 60%, 0.1)'

export const fadeInDurationMs = 1000
export const fadeOutDurationMs = 1000

// stop, r, g, b, a
export const grad = [
  // debugging values
  // [0, 255, 0, 0, 0.5],
  // [1, 0, 0, 0, 1],
  [0, 174, 255, 132, 0.43],
  [0.0001, 167, 217, 254, 0],
  [0.224, 169, 239, 255, 1],
  [0.6562, 178, 255, 230, 1],
  [0.9427, 178, 255, 230, 0],
]
